import { request } from "../../config/helpers/axios-instance"
import MutlipleAddressPrint from "../address-print/multipleAddressPrint";
import React from "react";

async function fetchAddress(addressId, orderId) {
    const [addressRes, orderRes] = await Promise.all([
        request({ url: `/address/admin?id=${addressId}`, method: "GET" }),
        request({ url: `userOrder/admin/orderDetails/${orderId}`, method: "GET" }),
    ]);
    const bill_no = orderRes?.data?.data?.additionalDetails?.billNumber ?? null;
    return { address: addressRes.data.data.rows[0], orderId, bill_no }
}

export async function printMultipleAddress(selectedRows, AddopenModal) {
    const addresses = await Promise.all(
        selectedRows.map((row) => {
            return fetchAddress(row.addressId, row.orderId)
        })
    )
    AddopenModal(() => MutlipleAddressPrint({ addresses }));
}
export const isRowSelected = (row, selectedRows) => {
    let preSelectedRows = [...selectedRows];
    for (let index = 0; index < selectedRows.length; index++) {
        const element = preSelectedRows[index];
        if (element.orderId === row.original.id) {
            return index
        }
    }
    return null;
}


// markAllAsDelivered / markAllAsShipInTransit used to live here. They were copied
// verbatim when this file was forked from src/components/orderTable/helpers.js and
// were never adapted to quotations, which made them actively dangerous:
//
//   - selectedRows entries are built as `{ orderId: row.original.id }` in
//     table-layout.jsx, where `row.original.id` is a QUOTATION id.
//   - Both helpers then issued `PUT /userOrder/admin/id/{that id}` -- the ORDER
//     endpoint. Quotation ids and order ids are independent sequences that overlap
//     heavily (quotations run 2..17104+, orders 1..14227+), so marking quotation #2
//     as "DELIVERED" silently overwrote the status of ORDER #2 -- a different
//     record, a different patient, with no error shown.
//   - The statuses themselves were never valid here either: quotation STATUS_MAP
//     (Constants.js) has no DELIVERED and no SHIPPED_IN_TRANSIT.
//
// There is no correct quotation-side equivalent to write instead, so the two
// toolbar buttons were removed rather than repointed. Per-row status changes still
// work through the Status cell, which correctly uses PUT /quotation/admin/id/{id}.

export const isInDelhi = (pincode) => {
    if (parseInt(pincode) >= 110001 && parseInt(pincode) <= 110110) {
        return true
    }
    return false
}



export const renderNameColumn = (row) => {
    return <div className="flex flex-row gap-2 items-center">
        <div title={!row.original.address ? 'Address not present' : isInDelhi(row.original.address.pincode) ? 'Delhi' : 'Out of delhi'} className={`rounded-[50%] h-3 w-3 ${!row.original.address ? 'bg-purple-600' : isInDelhi(row.original.address.pincode) ? ' bg-green-500' : ' bg-red-500'}`}></div>
        <h1>
            <b className="text-lg">
                {row.original.mapUserPatient.Patient.name} :
                &nbsp;
            </b>
            <span className="text-elm-500 text-lg">
                {row.original.mapUserPatient.Patient.contact_no}
            </span>
            {row.original.mapUserPatient.User.name !=
                row.original.mapUserPatient.Patient.name && (
                    <>
                        <b className="text-blue-500 text-lg">
                            &nbsp;{" "}
                            {[
                                row.original.mapUserPatient
                                    .relationship === "OLD"
                                    ? ""
                                    : row.original.mapUserPatient.relationship.toLowerCase(),
                            ]}
                        </b>
                        <br />
                        <b className="text-lg">
                            {row.original.mapUserPatient.User.name}:
                        </b>
                        &nbsp;
                        <span className="text-elm-500 text-lg">
                            {row.original.mapUserPatient.User.contact_no}
                        </span>
                    </>
                )}
        </h1>
    </div >
}
